export class ASetUserAppLocation {
  static readonly type = '[UserAppLocation] ASetUserAppLocation]';
  constructor(public readonly payload: 'AUTH' | 'APP') {}
}
